/** Browser mirror of src/shared/toolPresentation.ts. webMirrorContracts pins the body. */

type ToolOutputView = import('../../src/shared/wireContract.js').ToolOutputView;

/** The full cause stays readable even when the stored preview contains only the output tail. */
export function failureHeadline(output: ToolOutputView, decode: (text: string) => string): string {
  return decode(output.fullText ?? output.text).replace(/\s+/g, ' ').trim().replace(/^Error:\s*/i, '') || output.status || 'failed';
}

/** Termination is independent of exit code. Painting/localization belongs to each surface. */
export function shellOutcome(result: { killed?: 'timeout' | 'abort' | 'overflow'; exitCode: number | null }): { failed: boolean; reason?: 'timeout' | 'abort' | 'overflow' | 'failed'; exitCode: number | null } {
  return { failed: result.killed !== undefined || result.exitCode !== 0, reason: result.killed ?? (result.exitCode === null ? 'failed' : undefined), exitCode: result.exitCode };
}

/** Hide short live and settled clocks without changing measured transcript durations. */
export function visibleToolDuration(durationMs: number | undefined): number | undefined {
  return durationMs !== undefined && durationMs >= 5000 ? durationMs : undefined;
}
